/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CaseStatusEnum {
    OPEN = 'open',
    ARCHIVED = 'archived',
}